import { PAYMENT_METHODS_API } from 'constants/AppConstants';
import { logError } from 'utils/logger.utils';

// #genai Phase 2 — GET the unified list of saved payment methods (cards + ACH banks).
// A 404 with no body means ENABLE_MULTI_PAYMENT_METHODS is OFF server-side. Per the Phase 2
// integration (no fallback to Phase 1), this is surfaced as a distinct error state
// (errorType: 'FeatureUnavailable') so the list can show a retry banner instead of silently
// downgrading. Other non-200s carry a model.Error body.
const getPaymentMethods = async () => {
  try {
    const response = await fetch(PAYMENT_METHODS_API);
    if (response.status === 404) return { ok: false, status: 404, json: { errorType: 'FeatureUnavailable' } };
    const json = await response.json();
    if (response.status !== 200) return { ok: false, status: response.status, json };
    return { ok: true, status: 200, json };
  } catch (error) {
    logError('getPaymentMethods failed', error);
    return { ok: false, status: 0, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default getPaymentMethods;
